import i18n from "@/i18n";
import { getDataHighVolumeUSD } from "@services/alert/high-volume-usd";
import dayjs from "dayjs";

const state = {
    autoRefreshTimeOffset: 1,
    loading: false,
    alertData: [],
    alertHeader: [
        { text: i18n.t("common.table.login"), value: "login" },
        {
            text: i18n.t("common.table.name"),
            value: "name",
            sortable: false,
        },
        { text: "Book", value: "books" },
        {
            text: i18n.t("common.table.ccy"),
            value: "ccy",
        },
        {
            text: i18n.t("common.table.today_open_volume_usd"),
            value: "today_open_volume_usd",
        },
        {
            text: i18n.t("common.table.most_today_opened_volume_usd_symbol"),
            value: "most_today_opened_volume_usd_symbol",
        },
        {
            text: i18n.t("common.table.today_open_trades_profit"),
            value: "today_open_trades_profit",
        },
        {
            text: i18n.t("common.table.trigger_time"),
            value: "trigger_time",
        },
    ],
    alertDataAmount: 0,
    csvHeader: {
        "Server Name": "server_name",
        Login: "login",
        Name: "name",
        Book: "books",
        CCY: "ccy",
        "Volume USD(Today)": "today_open_volume_usd",
        Symbol: "most_today_opened_volume_usd_symbol",
        "PNL USD(Today)": "today_open_trades_profit",
        "Trigger Time": "trigger_time",
    },
    selectedDate: null,
};

const actions = {
    getDataHighVolumeUSDAction({ commit }, data) {
        commit("UPDATE_LOADING", true);
        getDataHighVolumeUSD(data).then((res) => {
            res.data.data.forEach((item) => {
                item["books"] = item["books"]?.replace(/[[\]]/g, "") || "N/A";
            });
            commit("UPDATE_ALERT_DATA", res.data.data);
            commit("UPDATE_AMOUNT", res.data.count);
            commit("UPDATE_LOADING", false);
        });
    },
};

const mutations = {
    UPDATE_MONITOR_DATA(state, data) {
        state.monitorData = data;
    },
    UPDATE_ALERT_DATA(state, data) {
        state.alertData = data;
    },
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_ALERT_HEADER(state, data) {
        state.alertHeader = data;
    },
    UPDATE_SELECTED_DATE(state, data) {
        state.selectedDate = dayjs(data).unix();
    },
    UPDATE_AMOUNT(state, data) {
        state.alertDataAmount = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
